export function coordinatorService(http) {
    const serviceName = "Coordinator";

    return {
        getCartable: (userId,roleMembers,pageNumber,pageSize,sortBy,startDate,endDate,cartableTypeId,filters) => {

            const newSortBy=(sortBy||[]).map(item=>( {member:item.id,sortDirection:item.desc?"Descending":"Ascending"}))

            const newfilter= Object.keys(filters).map(key => {
                return {
                    member:key,
                    operator:filters[key].operator,
                    value: filters[key].columnType=="number"?Number(filters[key].value):filters[key].value
                };
              });
            const filter= cartableTypeId==1
            ?{
                logic:"And",
                filters:[
                    ...newfilter,
                    {
                        member:"StartDate",
                        operator:"GreaterThanOrEqualTo",
                        value:startDate
                    },
                    {
                        member:"StartDate",
                        operator:"LessThan",
                        value:endDate
                    }
                ]
            }
            :newfilter.length>0 
                ?{
                    logic:"And",
                    filters:newfilter
                }
                :null;

            const data = {
                    user:{
                        id:userId
                    },
                    cartableTypeId,
                    startDate,
                    endDate,
                    roleMembers,
                    dataAttribute:{
                        page:pageNumber,
                        pageSize,
                        sorts:newSortBy.lenght==0?[{ member:"StartDate", sortDirection:"Ascending"}] : newSortBy,
                        filter:filter
                    }
            };
            return http.post(serviceName + "/GetCartable",data);//.then(result=>result.data );
        },
        initializeTasks:(formData)=>{
            
            const data = {
                InitiateTasks:formData
            };
            return http.post(serviceName + "/SaveTasks",data);//.then(result=>result.data );
        },
        initializeTasksToHold:(formData)=>{
            
            const data = {
                InitiateTasks:formData
            };
            return http.post(serviceName + "/InitiateTasksToHold",data);
        },

        saveCustomActivity:(formData)=>{
            const data = {
                ...formData
            }
            return http.post(serviceName + "/SaveCustomActivityTask",data);//.then(result=>result.data );
        },
        finalResponsibleTask:(keyId,keyGId,keyStatusTypeId,userId,uniqueId,workflowCategoryType)=>{
            const data={
                        keyId,
                        keyGId,
                        keyStatusTypeId,
                        user:{
                            id:userId
                        },
                        uniqueId,
                        workflowCategoryType
            }
            return http.post(serviceName + "/FinalResponsibleTask",data)
        },
        finalTask:(keyId,keyStatusTypeId,userId,uniqueId,workflowCategoryType,holdReasonId,activityTypeId)=>{
            const data={
                        keyId,
                        
                        keyStatusTypeId,
                        user:{
                            id:userId
                        },
                        uniqueId,
                        workflowCategoryType,
                        holdReasonId,
                        activityTypeId
            }
            return http.post(serviceName + "/FinalTaskCycle",data)
        }
    }
}